import Navigation from "../components/navigation";
import Footer from "../components/footer";
import HeadingTitle from "../pkg/components/heading-title";
import SubHeadingTitle from "../pkg/components/sub-heading-title";
import { companyName, navigation } from "../config/constants";
import Header from "../components/header";
import Main from "../pkg/components/main";
import Paragraph from "../pkg/components/paragraph";
import LeadParagraph from "../pkg/components/lead-paragraph";

function Home() {
    return (
        <>
            <Navigation companyName={companyName} navigation={navigation} />

            <Main>
                <Header>Intelligent software of tomorrow.<br />Delivered today.</Header>

                <HeadingTitle>The Broken Promise</HeadingTitle>

                <LeadParagraph>
                    Over the past decade, tech leaders promised a revolution in software development and business operations.
                    Their vision included rapid modernization of tech stacks, migration to SaaS platforms for non-core services,
                    and data-driven innovation to enhance competitiveness. This transformation was meant to increase development
                    productivity while reducing infrastructure costs.
                </LeadParagraph>

                <LeadParagraph>
                    However, reality has diverged from these promises. Development
                    teams have grown larger, not to drive innovation but to navigate a fragmented landscape characterized by new job
                    titles, endless choices, vendor lock-in, and unpredictable costs.
                </LeadParagraph>

                <LeadParagraph>
                    <span className="text-[#f7f8f8]">We solved this.</span> We have built an automated <u>process-centric system</u> that combines industry-standard
                    cloud-native tools with development best practices to build and deliver software that
                    enables faster development, easier scaling, and reduced IT costs.
                </LeadParagraph>

                <div className="grid grid-cols-1 gap-8 lg:grid-cols-3 my-24">
                    <div className="bg-[#0b0b0b] hover:bg-black cursor-pointer  rounded-3xl p-8">
                        <div className="text-2xl text-white font-semibold">
                            Codex
                        </div>
                        <div>
                            The Source of Truth
                        </div>
                    </div>

                    <div className="bg-[#0b0b0b] hover:bg-black cursor-pointer rounded-3xl p-8">
                        <div className="text-2xl text-white font-semibold">
                            Automata
                        </div>
                        <div>
                            Agentic Engineers
                        </div>
                    </div>

                    <div className="bg-[#0b0b0b] hover:bg-black cursor-pointer rounded-3xl p-8">
                        <div className="text-2xl text-white font-semibold">
                            Opteron
                        </div>
                        <div>
                            Closed-Loop Operations
                        </div>
                    </div>
                </div>

                <HeadingTitle>Codex</HeadingTitle>
                <SubHeadingTitle>The Source of Truth</SubHeadingTitle>

                <Paragraph>
                    Every enterprise runs on rules. Most are buried in code, documents, dashboards, and institutional memory. We surface them. 
                    By defining business logic in a live ontology, we capture policy, process, regulation, and intent in one cohesive structure. 
                    This is not a reference manual — it is the operational heartbeat. Systems read from it. People reason with it. Change it, and 
                    everything downstream updates with precision.
                </Paragraph>

                <HeadingTitle>Automata</HeadingTitle>
                <SubHeadingTitle>Agentic Engineers</SubHeadingTitle>

                <Paragraph>
                    Development is no longer bottlenecked by bandwidth. AI agents convert ontology into executable software—code that reflects the 
                    business as it is, not as it was. Graph-driven, context-aware, continuously improving. These agents write, test, and adapt while 
                    humans steer. The result: systems that are aligned from spec to syntax. The distance between idea and implementation collapses.
                </Paragraph>
                

                <HeadingTitle>Opteron</HeadingTitle>
                <SubHeadingTitle>Closed-Loop Operations</SubHeadingTitle>

                <Paragraph>
                    Deployment is just the first move. Every system observes itself. Telemetry, user interaction, failure states—they flow into a 
                    monitoring layer that feeds back into the ontology. When the business shifts, the system responds. New insights trigger dynamic 
                    updates to logic. Entire workflows evolve autonomously. No tickets. No silos. Just systems that get better—continuously, and at scale.
                </Paragraph>

            </Main>

            <Footer />
        </>
    );
}

export default Home;
